import React, { useCallback } from "react";
import {
    StyleFunction,
    useAuth,
    useForm,
    useThemedStyle,
} from "@venuepos/react-common";
import { RootStackScreenProps } from "../../../navigation";
import {
    GQLayoutEntityCreate,
    useLayoutEntityCreateMutation,
} from "graphql-sdk";
import { defaultLayoutEntity, schemaLayoutEntity } from "lib";
import { useHandleMutationError } from "../../../hooks";
import { AdminContainer } from "../../container";
import { View } from "react-native";
import { Form } from "../form";
import { useTranslation } from "react-i18next";

type ScreenProps = RootStackScreenProps<"LAYOUT_ENTITY_CREATE">;

export function LayoutEntityCreateScreen({
    navigation: { navigate },
}: ScreenProps) {
    const auth = useAuth();
    auth.enforce("merchant.layout.write");

    const [t] = useTranslation();
    const [layoutEntityCreate] = useLayoutEntityCreateMutation();

    const form = useForm<GQLayoutEntityCreate>(
        schemaLayoutEntity,
        defaultLayoutEntity
    );

    const [{ values }, { reset }] = form;
    const styles = useThemedStyle(styleFunc);
    const { handleMutationError } = useHandleMutationError();

    const handleSave = useCallback(async () => {
        if (!values) {
            return;
        }

        await handleMutationError(
            async () =>
                await layoutEntityCreate({
                    variables: {
                        layoutEntity: {
                            name: values.name,
                            type: values.type,
                            function: values.function,
                            data: values.data,
                        },
                    },
                }),
            t("common.saved", "Saved"),
            () => {
                reset();
                navigate("LAYOUT_ENTITIES", { refetch: true });
            }
        );
    }, [values, handleMutationError, t, layoutEntityCreate, reset, navigate]);

    return (
        <AdminContainer>
            <View>
                <View style={styles.formBox}>
                    <Form
                        form={form}
                        onSubmit={handleSave}
                        submitButton={["common.save", "Save"]}
                    />
                </View>
            </View>
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = theme => ({
    formBox: {
        maxWidth: theme.dimensions.maxFormWidth,
    },
});
